module.exports = __webpack_public_path__ + "img/bz1.bc30e9b6.jpg";